import { memo } from 'react'
import { observer } from 'mobx-react-lite'
import { CardString, Suit, Value } from 'pokersolver'
import { StyleSheet, View } from 'react-native'
import { useStore } from '../../../models'
import { PlayerBettingChips } from '../PlayerBettingChips'
import { useTableTourPositioning } from '../../../hooks/usePositioning'
import { Indicator } from '../Indicator/Indicator'
import { useResponsive } from '@/screens/new-design/hooks'
import { PokerCard } from '@/components/GameAssets/Cards/PokerCard'

interface PlayerCardsProps {
  cards?: CardString[]
  isThreeCard?: boolean
}

const PlayerCardsImpl = observer(({ cards, isThreeCard }: PlayerCardsProps) => {
  const {
    game: { isMyPlayerFoldedOrWaiting, myPlayer, currentStep, walkthroughType, winners, step }
  } = useStore()

  const { verticalScale } = useResponsive()

  const { ref, onLayout } = useTableTourPositioning({ key: 'hole', shouldSave: () => true })
  const showIndicator = walkthroughType === 'RaiseOrFold' && currentStep?.id === myPlayer?.id && step > 0
  const isWinner = myPlayer && winners.length && winners[0].playerName === myPlayer.name
  const notWinner = winners.length !== 0 && !isWinner

  const isCardDisabled = isMyPlayerFoldedOrWaiting || notWinner

  return (
    <>
      <View key={cards?.join('')} style={styles.container}>
        {!isThreeCard ? (
          <View style={styles.chipsContainer}>
            {myPlayer ? (
              <PlayerBettingChips player={myPlayer} horizontal />
            ) : (
              <View style={{ height: 20, backgroundColor: 'transparent' }} />
            )}
          </View>
        ) : null}
        <View
          ref={ref}
          onLayout={onLayout}
          style={[
            styles.cardsContainer,
            { opacity: winners.length ? (isWinner ? 1 : 0.4) : 1, gap: isThreeCard && isWinner ? 5 : 10 }
          ]}
          collapsable={false}
        >
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              gap: 10,
              paddingHorizontal: isThreeCard ? 0 : 10
            }}
          >
            {showIndicator ? <Indicator /> : null}
            <PokerCard.Flip
              suit={cards?.[0]?.[1] as Suit | undefined}
              value={cards?.[0]?.[0] as Value | undefined}
              side={cards?.[0] !== undefined ? 'front' : 'back'}
              size={verticalScale(48)}
              soundEnable
              containerStyle={{
                transform: [{ rotate: '-5deg' }],
                opacity: isCardDisabled ? 0.8 : 1
              }}
            />
            <PokerCard.Flip
              suit={cards?.[1]?.[1] as Suit | undefined}
              value={cards?.[1]?.[0] as Value | undefined}
              side={cards?.[1] !== undefined ? 'front' : 'back'}
              size={verticalScale(48)}
              soundEnable
              containerStyle={{
                transform: [{ rotate: '5deg' }],
                opacity: isCardDisabled ? 0.8 : 1
              }}
            />
          </View>
        </View>
      </View>
    </>
  )
})

export const PlayerCards = memo(PlayerCardsImpl, (prevProps, nextProps) => {
  return prevProps.cards?.[0] === nextProps.cards?.[0] && prevProps.cards?.[1] === nextProps.cards?.[1]
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20
  },
  chipsContainer: {
    flex: 1
  },
  cardsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center'
    //padding: 10,
  }
})
